import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Logo";
import { errMsg } from "@/lib/api";
import { IMG } from "@/data/site";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full rounded-2xl bg-cream/5 border border-cream/15 px-5 py-4 text-cream outline-none focus:border-terra-soft transition-colors placeholder:text-cream/50";
  return (
    <main className="min-h-screen grid lg:grid-cols-2 bg-ink text-cream" data-testid="admin-login-page">
      <div className="hidden lg:block relative overflow-hidden">
        <img src={IMG.kazbegi} alt="" className="absolute inset-0 h-full w-full object-cover opacity-70" />
        <p className="absolute bottom-10 left-10 font-serif italic text-5xl">Back office.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <Logo light />
          <h1 className="font-display text-4xl font-extrabold tracking-tight pt-6">Admin sign in</h1>
          <input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="admin-login-email-input" />
          <input type="password" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={input} data-testid="admin-login-password-input" />
          {error && <p className="text-sm text-terra-soft" data-testid="admin-login-error">{error}</p>}
          <button disabled={busy} data-testid="admin-login-submit-btn"
            className="w-full rounded-full bg-terra py-4 font-semibold hover:bg-[#a5370a] transition-colors disabled:opacity-60 inline-flex justify-center items-center gap-2">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </main>
  );
}
